<template>
  <!-- Responsive SOS page layout -->
  <v-app>
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <NavBar />
        </v-col>

        <!-- Page Heading -->
        <v-col cols="12">
          <h1 class="page-title">SOS Page</h1>
        </v-col>

         <!-- Important Note -->
        <v-col cols="12">
          <p class="important-note">
            Below is a list of resources to help you find urgent support. If you need help, don’t hesitate to ask. Your safety comes first.
          </p>
        </v-col>

        <!-- Emergency Help Options -->
        <v-col cols="12">
          <h2 class="section-header">Emergency Help Options</h2>
          <ul class="sos-list">
            <li>
              <a :href="'tel:911'" class="sos-link">Call 911 – For immediate emergencies.</a>
            </li>
            <li>
              <a :href="'tel:988'" class="sos-link">Call 988 Suicide & Crisis Lifeline – Call for urgent mental health support.</a>
            </li>
          </ul>
        </v-col>

        <!-- Text or Chat for Help -->
        <v-col cols="12">
          <h2 class="section-header">Text or Chat for Help</h2>
          <ul class="sos-list">
            <li>
              <a :href="'sms:+741741?body=HELLO'" class="sos-link">
                Text "HELLO" to 741741 – Crisis Text Line for urgent support via text.
              </a>
            </li>
          </ul>
        </v-col>

        <!-- Personal Support -->
        <v-col cols="12">
          <h2 class="section-header">Personal Support</h2>
          <ul class="sos-list">
            <li>
              <span class="sos-description">Contact My Therapist – Quick access to your therapist’s contact information.</span>
            </li>
            <li>
              <span class="sos-description">Contact My Emergency Contact – Call or text your designated support person.</span>
            </li>
          </ul>
        </v-col>

        <!-- Other Support Resources -->
        <v-col cols="12">
          <h2 class="section-header">Other Support Resources</h2>
          <ul class="sos-list">
            <li>
              <span class="sos-description">Find Local Mental Health Services – Search for nearby mental health facilities or crisis centers.</span>
            </li>
            <li>
              <span class="sos-description">View My Safety Plan – Review the personal safety plan set up with your therapist.</span>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-container>

    <!-- Footer -->
    <MENDFooter></MENDFooter>
  </v-app>
</template>

<script>
import MENDFooter from './MENDFooter.vue';
import NavBar from './NavBar.vue';

export default {
  name: 'SOS',
  components: {
    NavBar,
    MENDFooter,
  },
};
</script>

<style scoped>
* {
  font-family: 'Montserrat', sans-serif;
}

.page-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 20px;
  color:#000000;
}

.section-header {
  color: #08b6aa; /* Aqua Teal */
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.sos-list {
  list-style-type: none;
  padding: 0;
}

.sos-list li {
  margin-bottom: 10px;
}

.sos-link,
.sos-description {
  color: #293840; /* Charcoal Blue */
  font-size: 1rem;
}

.sos-link:hover {
  color: #ff6d44; /* Bright Orange */
  text-decoration: underline;
}
</style>

